/* Discrete page entrances, scoped to Shopify section lifecycles. */
(() => {
  if (!window.gsap || !window.ScrollTrigger) return;
  gsap.registerPlugin(ScrollTrigger);
  const instances = new Map();
  const selector = '.pg-faq,.pg-journal,.template-product main .shopify-section';
  function mount(root) {
    if (instances.has(root)) return;
    const mm = gsap.matchMedia();
    mm.add('(prefers-reduced-motion: no-preference)', () => {
      if (window.Shopify?.designMode) return;
      const targets = root.matches('.pg-faq') ? root.querySelectorAll('.pg-faq-intro,.pg-faq-tools,.pg-faq-contact') : root.matches('.pg-journal') ? root.querySelectorAll('.pg-journal-intro,.pg-journal-card') : root.querySelectorAll('.product__media-wrapper,.product__info-wrapper,.pg-product-story-image,.pg-product-story-copy');
      targets.forEach(el => gsap.from(el, {y: 22, opacity: 0, duration: .85, ease: 'power2.out', clearProps: 'transform,opacity', scrollTrigger: {trigger: el, start: 'top 94%', once: true}}));
    }, root);
    instances.set(root, mm);
  }
  const scan = parent => {if (parent.matches?.(selector)) mount(parent);parent.querySelectorAll(selector).forEach(mount);};
  scan(document);
  document.addEventListener('shopify:section:load', e => scan(e.target));
  document.addEventListener('shopify:section:unload', e => instances.forEach((mm, root) => {if (e.target.contains(root)) {mm.revert();instances.delete(root);}}));
})();
